<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 3s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

    @keyframes d-pushup-1 {
    0%,
    20% {
      opacity: 1;
    }
    20%,
    100% {
      opacity: 0;
    }
  }
  #d-pushup-1 {
    animation-name: d-pushup-1;
  }
  @keyframes d-pushup-2 {
    0%,
    20% {
      opacity: 0;
    }
    20%,
    40% {
      opacity: 1;
    }
    40%,
    100% {
      opacity: 0;
    }
  }
  #d-pushup-2 {
    animation-name: d-pushup-2;
  }
  @keyframes d-pushup-3 {
    0%,
    40% {
      opacity: 0;
    }
    40%,
    60% {
      opacity: 1;
    }
    60%,
    100% {
      opacity: 0;
    }
  }
  #d-pushup-3 {
    animation-name: d-pushup-3;
  }
  @keyframes d-pushup-4 {
    0%,
    60% {
      opacity: 0;
    }
    60%,
    80% {
      opacity: 1;
    }
    80%,
    100% {
      opacity: 0;
    }
  }
  #d-pushup-4 {
    animation-name: d-pushup-4;
  }
  @keyframes d-pushup-5 {
    0%,
    80% {
      opacity: 0;
    }
    80%,
    100% {
      opacity: 1;
    }
  }
  #d-pushup-5 {
    animation-name: d-pushup-5;
  }
}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 743.9 410.2" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="d-pushup-3">
      <path
        fill="var(--shirt)"
        d="M464 259c-17-9-33-23-55-22-6-5-13-4-20-5-9 0-12-4-9-13 2-4 3-9 6-12 21-12 31-33 40-54 5-14 5-29 9-43 15 4 26 14 37 23 29 24 63 40 94 62 17 13 27 31 30 53l2 9a103 103 0 0 1-6 30c-4-1-8 0-11-2-11-9-19-3-25 6s-13 9-20 0c-1-2-3-4-6-4-11-6-20-15-33-17-8-3-14-10-24-9Z"
      />
      <path
        fill="var(--pants)"
        d="M435 110c-4 14-4 29-9 43-9 21-19 42-40 54-3-6-8-1-12-2h-3c-3 0-7-2-8 3a24 24 0 0 1-3 0c-25-6-44 8-63 21-7 5-15 10-25 9-9-14-11-30-13-45-1-9 0-18 8-23 5-4 5-8 1-12-2-6-1-10 5-14 20-14 39-29 60-42 32-22 68-22 94-1 4 3 6 5 8 9Z"
      />
      <path
        fill="var(--flesh)"
        d="M268 158c4 4 4 8-1 12-8 5-9 14-8 23 2 15 4 31 13 45-18 12-36 23-58 27-32 7-59 24-89 35-9 4-19 5-26 12-7-1-11 3-15 6-7 4-13 9-20 12-6 4-14 5-20 0-6-4-6-10-6-16 1-8 7-14 13-16 20-5 20-24 26-38 32-10 57-33 88-46 11-5 22-8 34-10 15-2 30-7 41-20 9-9 16-20 28-26ZM473 261c10-1 16 6 24 9-1 27-1 28 37 30-2-4-5-8-4-13 3 0 5 2 6 4 7 9 13 9 20 0s14-15 26-6c2 2 7 1 10 2 4 5 3 10 1 16a293 293 0 0 0-8 36c-1 4-4 10 5 11-8 4-7 12-5 18 2 7 8 1 11 2 14 3 29 1 42 9 5 3 9 7 6 11-3 5-6 13-14 11-17-6-36-4-54-5-9 0-15-4-16-13-4-18-8-36-10-55-2-11-6-13-15-11-10 1-19 2-29 0-22-4-26-7-30-29l-2-10-2-3 1-14Z"
      />
      <path
        fill="var(--hair)"
        d="M77 260c-6 14-6 33-26 38-6 2-12 8-13 16 0 6 0 12 6 16 6 5 14 4 20 0 7-3 13-8 20-12 4-3 8-7 15-6-2 10 6 9 11 10 5 2 11 2 11 9 1 8-7 8-12 9-11 2-23 5-33-4-4-1-4 1-3 4 5 12 11 21 25 21 6 0 10 3 11 9 0 5-4 8-8 10-23 14-51 9-69-12L4 332c-6-7-4-12 4-16 10-6 19-12 29-16 9-3 11-8 4-15-6-6-5-10 4-14 10-5 20-11 32-11ZM590 350c-9-1-6-7-5-11a293 293 0 0 1 8-36c2-6 3-11-1-16a103 103 0 0 0 7-30c12 9 22 19 30 32 10 14 7 28-5 39-10 10-23 15-34 22Z"
      />
    </g>
    <g id="d-pushup-2">
      <path
        fill="var(--pants)"
        d="M289 0c10 6 20 12 32 14l2 4c0 40-10 77-27 113-1 3-5 3-7 5l-7 1v-1 1c-25 0-40 19-59 32l-32-66c9-44 29-81 73-99 2-1 5-1 5-4Z"
      />
      <path
        fill="var(--shirt)"
        d="M289 136c2-2 6-2 7-5 17-36 27-73 27-113l-2-4c12-2 19 8 28 12 28 11 56 26 84 39s54 27 75 51c3 8 4 17 10 24v30c1 13-6 13-13 9-10-5-20-2-29-3-3 0-6 1-6 5 1 13-9 11-16 12-2-2-2-6-4-6-34-5-61-28-94-37-18-4-36-11-55-8-6 1-9-2-12-6Z"
      />
      <path
        fill="var(--flesh)"
        d="M454 193c7-1 17 1 16-12 0-4 3-5 6-5 9 1 19-2 29 3 7 4 15 4 13-9v-30l9 2c8 0 16 2 16 11s-9 7-15 7c-2 0-5 1-6 3 0 3 2 5 4 7 8 3 15 8 23 10s8 5 5 11l-6 9c-26-9-31-5-29 21 1 12 7 22 16 29l29 95c5 17 17 21 32 23 14 1 29 4 42 10 5 3 9 10 8 11-5 4-6 14-15 11-18-7-36-5-54-5-8-1-14-4-19-11-10-17-22-33-29-51-7-15-18-21-33-20-14 0-20-7-24-19-10-28-19-55-16-85l-2-16Zm27 31c-2 21 2 38 5 56 2 14 8 16 20 12-7-22-11-45-25-68ZM191 103l32 66c-11 2-14 12-19 19-10 14-22 24-37 33-21 12-35 31-52 48a112 112 0 0 1-18 14c-5 4-10 8-11 15-7 1-10 7-12 12-3 12-19 12-22 24l-6 2c-13 1-18-7-17-27l6-3 9-11c5-9 15-14 14-26 25-22 36-57 64-76l1-1c32-15 45-45 58-75 2-5 3-11 10-14Z"
      />
      <path
        fill="var(--hair)"
        d="M29 309c-1 20 4 28 17 27l6-2c3-12 19-12 22-24 2-5 5-11 12-12 6 12 14 23 30 23 4 0 8 1 8 6s-2 7-7 8c-17 4-34 7-47-10-2 16 5 25 18 29l15 4c5 1 11 0 11 8 0 7-5 12-10 12-10-1-19 5-28 6-19 3-33-1-46-15L6 346c-7-6-9-12 0-19 8-6 13-16 23-18ZM548 200l6-9c3-6 3-9-5-11s-15-7-23-11c-2-1-4-3-4-6 1-2 4-3 6-3 6 0 15 2 15-7 0-10-8-11-16-11l-9-2c-6-7-7-16-10-24 18 1 36-3 54 2 16 5 22 15 21 31-1 20-10 37-16 54-5 12-12 3-18 0ZM58 269c1 12-9 17-14 26l-9 11c-9-11-5-19 6-26 6-4 10-10 17-11Z"
      />
      <path fill="var(--shirt)" d="M282 137v-1 1z" />
    </g>
    <g id="d-pushup-1">
      <path
        fill="var(--shirt)"
        d="M516 199c-22 6-44 13-65 22-6 3-12 0-18 1-8 2-16 4-23 4-6 0-8-1-8-7l-2-8c-2-16-5-31-4-47a16 16 0 0 0-3-8c-6-12-8-24-7-37a121 121 0 0 0 29-6 9 9 0 0 1 2-1c25-1 46-13 68-20a46 46 0 0 1 13-2c2 0 5 0 6-3h48c3 6 9 3 14 5 14 3 24 13 38 16l3 8c-4 8-4 17-6 26-2 12-5 24-4 37-5 10-4 22-6 32-1 6 0 13-6 18-3-5-10-5-11-5-10 4-19 0-29 2-2-1-5-2-7 0-4-1-4-4-4-7a177 177 0 0 1 0-18c1-7-3-8-8-6l-10 4Z"
      />
      <path
        fill="var(--hair)"
        d="m607 116-3-8c16-6 32-16 49-19l1-2h12c24 6 26 26 30 44l4 29c2 10-1 13-10 11l-11-4c1-3 3-5 3-8 2-9-1-11-9-9-4 1-6 0-8-2-3-5-8-7-14-6-3 1-6 0-10-1s-7-3-8-7c-1-5 4-5 6-7 6-3 10-7 6-13-3-6-8-4-13-2-8 3-16 9-25 4Z"
      />
      <path
        fill="var(--pants)"
        d="M386 119c-1 13 1 25 7 37a16 16 0 0 1 3 8c-1 16 2 31 4 47a9 9 0 0 0-6 5c-6 9-15 14-25 18-14 4-27 10-41 13a274 274 0 0 0-62 24c-4 2-7 0-9-3l-10-13c0-4 8-3 4-9-9-14-16-29-22-44a5 5 0 0 1 3-5c16-8 30-20 46-30a579 579 0 0 0 55-36c16-12 34-18 53-12Z"
      />
      <path
        fill="var(--flesh)"
        d="M229 202c6 15 13 30 22 44 4 6-4 5-4 9-9 0-16 6-25 8-14 3-28 3-42 8-8 2-14 8-22 11l-32 12c-11 2-22 3-31 11-7 5-16 8-20 17-5-1-8 5-12 4-6-1-13-2-19-6s-8-11-3-17c3-3 5-7 4-11 14-2 25-10 36-17l2-4c14-4 27-10 34-25a9 9 0 0 0 7-1c12-8 27-12 38-20 20-16 42-22 67-23ZM545 226c10-2 19 2 29-2 1 0 8 0 11 5-4 37-9 74-16 111l-2 21c-1 7 0 8 7 6 3 0 10-6 8 5 0 3 3 2 5 2l25 2c9 1 12 7 18 11 3 2 0 5 0 8 0 2-3 2-5 2-4 0-9-4-11 3h-8c-11-2-22-3-33-2a50 50 0 0 1-14-2c-11-3-14-7-14-18v-50c0-7-1-11-9-11l-8-1c-11-3-17-9-17-21-1-24 2-48 4-73 0-8 2-15 1-23l10-4c5-2 9-1 8 6a177 177 0 0 0 0 18c0 3 0 6 4 7l-9 51c-1 4-2 9 0 14s7 6 12 5 2-5 2-8c-1-20 3-41 2-62Z"
      />
      <path
        fill="var(--hair)"
        d="M45 292c1 4-1 8-4 11-5 6-3 13 3 17s13 5 19 6c4 1 7-5 12-4 3 1 1 3 0 4-7 9-2 17 0 26l4 1 21 7c7 2 7 11 1 14-14 8-30 14-47 9-11-3-19-9-23-21-5-13-13-26-19-39l-5-10c-1-6 1-9 5-13 10-8 22-5 33-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M607 116c9 5 17-1 24-4 6-2 11-4 14 2 4 6-1 10-6 13-2 2-7 2-6 7 1 4 4 6 8 7s7 2 10 1c6-1 11 1 14 6 2 2 4 3 8 2 8-2 10 0 9 9 0 3-2 5-3 8-9 3-16 9-26 9-4 1-8 5-11 9s-6 4-10 1l-2-2c-8 5-14-1-21 0-6 1-9-1-12-5-1-13 2-25 4-37 2-9 2-18 6-26Z"
      />
      <path
        fill="var(--hair)"
        d="M95 305c9-8 20-9 31-11-3 7 0 11 7 14a25 25 0 0 1 6 3c6 4 5 11-1 14a50 50 0 0 1-28 3 12 12 0 0 1-10-8l-5-15ZM117 246c-7 15-20 21-34 25-5-15-3-18 13-22 6-1 13-1 18-5 3-2 3 1 3 2Z"
      />
    </g>
    <g id="d-pushup-4">
      <path
        fill="var(--hair)"
        d="M744 336c-5 8-4 17-7 25-2 5 1 11-5 12s-10-2-14-6l5-10c1-5 3-11-6-8a4 4 0 0 1-4-2c-3-5-6-4-10-3-4 2-9 2-13 0a6 6 0 0 1-4-7c1-3 4-2 6-2h6c3 0 7-1 8-5 1-3 0-7-3-10s-8-4-12-4c-11 0-17-7-21-16 12-10 26-11 40-13 6 0 12-2 18 1 7 3 13 8 16 15ZM71 336l-10 23c-1 3-1 6 4 7a39 39 0 0 1 8 5c7 4 7 10 0 14-10 6-34 4-42-5-5-6-6-15-6-23 0-14 0-28-5-41-1-2-1-4-3-5v-13c15-4 31-3 47-3a2 2 0 0 1 2 2c-9-2-14 4-17 12l-3 4c-5 7-3 11 5 21 5 6 10 9 16 2h4Z"
      />
      <path
        fill="var(--pants)"
        d="M447 349c-9 3-15 11-25 12-23 1-45 3-68 2-15-1-29 1-44 4-11 2-13 1-16-10l-3-10c1-18-1-37-3-55 3-5 8-4 13-5 3-1 7-1 8-6 1-3 4-3 6-4l27-5a273 273 0 0 0 64-17 63 63 0 0 1 37-4c6 1 13 3 18 8-5 10-7 21-4 32v15a342 342 0 0 0-10 43Z"
      />
      <path
        fill="var(--flesh)"
        d="M288 292c2 18 4 37 3 55-21-5-42 0-63-3a50 50 0 0 1-9-3c-21-7-44-4-65-8-13-3-25-2-38-2-13-2-25 0-37 2-3 1-6 1-8 3h-4c-6 7-11 4-16-2-8-10-10-14-5-21l3-4c3-8 8-14 17-13h11a338 338 0 0 0 47-3c16 0 31-3 47-5 24-3 48-4 72 2 15 4 30 6 45 2Z"
      />
      <path
        fill="var(--shirt)"
        d="M447 349a342 342 0 0 1 10-43c2-5 1-10 0-15-3-11-1-22 4-32 6 3 13 3 18 9h3c11-3 21 4 32 1 11 1 20-6 31-3-1 3-5 1-6 4-1 7-5 13-6 19-2 19 3 36 7 54 2 9 5 17 5 26a273 273 0 0 0-43 3c-15 2-29-5-44-5l-5-1c-6 0-7-3-6-8 0-3 2-6 0-9Z"
      />
      <path
        fill="var(--flesh)"
        d="M545 369c0-9-3-17-5-26-4-18-9-35-7-54l6-19c1-3 5-1 6-4-11-3-21 4-31 3l2-8c2-4 4-8 10-8 15 0 31 0 45 8-1 2-4 3 1 4 12 2 25 3 35 12 7 5 9 9 6 18l-5 12c-1 4-1 10-6 11-3 1-5 4-7 6-5 8-11 9-18 5-4-2-6-1-6 3l-3 15c-1 7-3 15 2 22 0 6 2 8 8 8a228 228 0 0 1 56 10c2 1 4 1 4 5l-5 4c-24 5-48 0-72 1-5 0-8-3-9-8a88 88 0 0 0-7-20Z"
      />
      <path
        fill="var(--shirt)"
        d="M570 369c-5-7-3-15-1-22l2-15c0-4 2-5 6-3 7 4 13 3 18-5l7-6c5-1 5-7 6-11l5-12c3-9 1-13-6-18-10-9-23-10-35-12-5-1-2-2-1-4 15 1 29 2 42 7 17 6 31 15 43 29a148 148 0 0 1-9 43 133 133 0 0 1-26 25c-9 7-20 7-31 6l-20-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M647 340a148 148 0 0 0 9-43c4 3 9 2 14 3 4 9 10 16 21 16 4 0 9 1 12 4s4 7 3 10c-1 4-5 5-8 5h-6c-2 0-5-1-6 2a6 6 0 0 0 4 7c4 2 9 2 13 0 4-1 7-2 10 3a4 4 0 0 0 4 2c9-3 7 3 6 8l-5 10c-12 3-26-1-37 8l-4 1c-5-5-13-2-18-7l-2-2c-13-1-9-9-8-17 1-3 2-8-2-10Z"
      />
      <path
        fill="var(--hair)"
        d="M124 293a338 338 0 0 1-47 3c-1-7 2-9 10-9 13-1 25 0 37 6ZM79 333c12-2 24-4 37-2l-5 7c-7 11-7 12 4 19 2 2 4 4 4 7s-3 5-5 6c-12 4-23 2-34-2-4-2-5-6-5-11l4-24Z"
      />
    </g>
    <g id="d-pushup-5">
      <path
        fill="var(--flesh)"
        d="M628 208c-11 17-23 35-30 54-12 33-26 65-21 101 0 8 3 10 11 13 15 8 33 3 48 12 8 6 10 9 1 15l-6 7h-8c-8-6-17-5-26-5-46-3-39-6-46-40-7-35-6-70 1-106 13-14 21-30 22-50 0-16 3-18 19-16 3 0 6 1 9-1 8-3 14 1 18 7 3 3 3 8 8 9Z"
      />
      <path
        fill="var(--hair)"
        d="M120 342c0 5-1 9-7 9-9 1-13 7-18 13-6 7-5 11 3 15s6 10 0 14c-8 5-17 7-26 2s-14-13-13-24c0-14 2-29-6-43v-22a33 33 0 0 1 24-1c11 3 11-2 11-10v-25c0-4 1-9 7-7 11 3 24 1 35 8-7 4-14 7-17 16-3 10 8 14 8 23-6 1-13 0-19 2-8 2-14 7-13 17s10 8 16 7c7-2 11 1 15 6ZM713 100c-6 3-12 5-19 3-1-16-3-16-15-8l-18 9c-3 2-6 3-9 0s0-5 2-8c3-4 8-9 1-14-6-4-12-3-16 4-9 13-20 15-34 8 1-17 13-27 23-39 6-7 12-14 23-16 21-4 30 12 42 25 7 9 11 21 20 28Z"
      />
      <path
        fill="var(--shirt)"
        d="M628 208c-5-1-5-6-8-9-4-6-10-10-18-7-3 2-6 1-9 1-15-2-19 0-19 16-1 20-9 36-22 50-12 17-29 29-39 46-12 1-18-6-23-15-10-23-13-51-37-66v-3c17-5 26-19 37-30l2-3c2-2 4-4 4-8l12-29c10-20 29-28 48-36 14-6 30-9 45-13 9 3 18 4 22 14 5 13 10 25 19 36 4 21-7 38-14 56Z"
      />
      <path
        fill="var(--flesh)"
        d="M120 342c-4-5-8-8-15-6-6 1-15 3-16-7s5-15 13-17c6-2 12-1 19-2 0-9-11-13-8-23 3-9 10-12 17-16 22 3 43 2 65-3a71 71 0 0 1 39 4c36 14 70 5 104-11a26 26 0 0 1 3-1c3 9 8 18 1 27v4c6 16 4 33 3 50a353 353 0 0 1-70 8c-7 0-14-2-21-1-45 2-89-7-134-6Zm55-39c-14-3-26-3-37-2-3 0-6 1-7 5 0 2 0 4 2 4 13-3 27 3 42-7Z"
      />
      <path
        fill="var(--pants)"
        d="M345 340c1-16 3-33-3-49v-4c7-9 2-18-1-27 21-3 40-9 58-21 16-11 34-19 54-15 24 15 27 43 37 66l-15 18c-16 7-29 19-46 24-24 8-47 19-74 16-6-1-9-2-10-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M642 152c-9-11-14-23-19-36-4-10-13-11-22-14l4-8c14 7 25 5 34-8 4-7 10-8 16-4 7 5 2 10-1 14-2 3-5 5-2 9 3 2 6 1 9-1l18-9c12-8 14-8 15 8-13 18-22 42-49 45l-3 4ZM475 308l15-18c5 9 11 16 23 15 4 6 11 3 17 6 7 3 7 7 3 11-10 9-51 1-57-10l-1-4Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>